import { useQuery } from '@tanstack/react-query';

export interface Sector {
  name: string;
  roles: string[];
}

export const useSectors = () =>
  useQuery<Sector[]>({
    queryKey: ['sectors'],
    queryFn: async () => {
      const res = await fetch('/sectors.json');
      if (!res.ok) throw new Error('Failed to load sectors');
      return res.json();
    },
    staleTime: Infinity,
  });
